import React from "react";
import { Card, ProgressBar } from "react-bootstrap";
import "../../assets/css/icons.css";
import CustomDropdown from "./CustomDropdown";
import { withNamespaces } from "react-i18next";

const TaskCompleted = ({ apagarWidget, ...props }) => {
  const { t } = props;
  return (
    <div className="main-card-v2">
      <Card bsPrefix="card-flat">
        <Card.Header className="justify-content-between">
          <h6>
            <i className="icon-bell mr-2" />
            {t("TaskCompleted.title")}
          </h6>
          <CustomDropdown apagarWidget={apagarWidget} />
        </Card.Header>
        <Card.Body>
          <ProgressBar now={34} label={"34%"} />
        </Card.Body>
      </Card>
    </div>
  );
};
export default withNamespaces()(TaskCompleted);
